/* src/app/modules/search/components/doc-view/components/comments/comments.component.scss */
.comment-main-container {
  padding: 1rem;
  border-radius: 0.5rem;
  border: solid 1px var(--surface-400);
}
.comment-main-container .comment-body-container {
  max-height: 20rem;
  margin-right: -1rem;
  padding-right: 1rem;
  overflow-y: scroll;
}
.comment-main-container .comment-body-container .comment-message-body .comment-icon {
  height: 1.5rem;
  width: 1.5rem;
}
.comment-main-container .comment-body-container .comment-message-body .comment-icon .avatarText {
  font-size: 0.68rem;
}
.comment-main-container .comment-body-container .comment-message-body .comment-body-html {
  margin-left: 2.1rem;
}
.comment-main-container .comment-body-container .comment-message-body .deleteButton {
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
}
.comment-main-container .comment-body-container .comment-message-body:hover .deleteButton {
  opacity: 1;
}
.comment-main-container ::ng-deep p {
  margin: 0;
  padding: 0;
}
.comment-main-container ::ng-deep .ql-snow.ql-toolbar button svg,
.comment-main-container .ql-snow .ql-toolbar button svg {
  float: left;
  height: 0.875rem;
}
.comment-main-container ::ng-deep .ql-snow .ql-picker {
  font-size: 0.75rem;
}
/*# sourceMappingURL=comments.component.css.map */
